import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { Observable, ReplaySubject, filter, map, pipe } from 'rxjs';

import { Pipe, PipeTransform } from '@angular/core';
import { ZalamoObject } from 'Upload/upload/graphql';

import { GetQuickLinkGQL } from 'ZalamoLibrary/src/lib/ui/quick-link/graphql';

@Pipe({
  name: 'quickLinkForRouter',
  standalone: false,
})
export class QuickLinkForRouterPipe implements PipeTransform {
  current$ = new ReplaySubject<{ context: ZalamoObject; contextId: string }>(1);

  constructor(private getQuickLinkGQL: GetQuickLinkGQL) {}

  transform(context: any, contextId: string): Observable<string[]> {
    return this.getQuickLinkGQL
      .watch({ variables: { context, contextId } })
      .valueChanges.pipe(
        throwOnQueryError,
        filter(hasCompleteQueryData),
        map((result) => result.data['quickLink']['link']),
      );
  }
}
